import { OrderStatuses, PointStatuses } from '@app/models';
import { OrderStatusConfig, PointStatusConfig } from './order-status.model';

export const ORDER_STATUS_CONFIG: Record<OrderStatuses, OrderStatusConfig> = {
  [OrderStatuses.IN_PROGRESS]: {
    label: 'In Progress',
    variant: OrderStatuses.IN_PROGRESS,
    icon: 'pi-send',
  },
  [OrderStatuses.READY]: {
    label: 'Ready',
    variant: OrderStatuses.READY,
    icon: 'pi-clock',
  },
  [OrderStatuses.DONE]: {
    label: 'Done',
    variant: OrderStatuses.DONE,
    icon: 'pi-check',
  },
};

export const POINT_STATUS_CONFIG: Record<PointStatuses, PointStatusConfig> = {
  [PointStatuses.TO_APPROVE]: {
    label: 'To Approve',
    variant: PointStatuses.TO_APPROVE,
    icon: 'pi-send',
  },
  [PointStatuses.READY]: {
    label: 'Ready',
    variant: PointStatuses.READY,
    icon: 'pi-clock',
  },
  [PointStatuses.DONE]: {
    label: 'Done',
    variant: PointStatuses.DONE,
    icon: 'pi-check',
  },
};
